var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adComponent)?_c(_vm.adComponent,{tag:"component",attrs:{"data-test":_vm.name}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }